var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.438 32.438"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-check-circle",
    d: "M32.437 16.218A16.219 16.219 0 1116.218 0a16.219 16.219 0 0116.219 16.218zm-18.095 8.588l12.034-12.033a1.046 1.046 0 000-1.48l-1.48-1.48a1.046 1.046 0 00-1.48 0l-9.814 9.814-4.581-4.582a1.046 1.046 0 00-1.48 0l-1.48 1.48a1.046 1.046 0 000 1.48l6.8 6.8a1.046 1.046 0 001.48 0z",
    fill: "#0fb1a5"
  })));
}

export default SvgIconCheck;